import React from "react";
import { useDispatch } from "react-redux";
import Header from "../../Components/Header/Header";
import { SubscribeApi } from "../../Redux/Auth/Auth_Action";
import { toast } from 'react-toastify';
import { useNavigate } from "react-router-dom";

const PayPalCheckOut = () => {
    const navigate = useNavigate()
    const dipatchItem = useDispatch();
    const SubscribeFunc = (NewData, reduxStateToken, type) => {
        dipatchItem(SubscribeApi(NewData, reduxStateToken, type))
            .then((res) => {
                console.log(res?.data?.message);
                toast.success(`${res?.data?.message}`);
                navigate("/");
                // console.log("res", res);
            }).catch((e) => {
                console.log("errror from checkout page ", e);
            })
    }

    return (
        <div>
            <section className='profile my_subscription'>
                <Header />
                <div className='container px-4'>
                    <div className='row'>
                        <div className='col-lg-12 text-center'>
                            <p className='f-pop-bold f-43 mb-5 mt-3'>Renew Subscription</p>
                        </div>
                        {/* <div className='col-lg-4'>
                              <ProfileTab />
                            </div> */}
                        <div className='payment_component'>

                        </div>
                        <div className='col-lg-12 mb-5 res-pxx'>
                            <div className='row'>

                                <div className='col-lg-12'>
                                    <p className='f-pop-bold f-30 mb-4'>Payment Information</p>
                                    {/* <p className='f-mon-semibold f-20 mb-4 mt-4'></p> */}
                                    <p className='f-mon-semibold f-20 mb-4 mt-4'>
                                        Package Title
                                        <span className='mx-2'></span>
                                        :
                                        <span className='mx-2'></span>
                                        <span className='f-mon-bold clr-e0'>asd</span>
                                    </p>
                                    <p className='f-mon-semibold f-20 mb-4 mt-4'>
                                        Package Price
                                        <span className='mx-2'></span>
                                        :
                                        <span className='mx-2'></span>
                                        <span className='clr-e0 f-mon-bold clr-e0'>$21</span>
                                    </p>
                                </div>
                                <div className="col-lg-12 mt-4">

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    )
}

export default PayPalCheckOut;